/**
 * Created by coolguy on 2018/8/9.
 */
import React, { MouseEventHandler } from 'react';
const style = {
  img: {
    width: 25,
    //height:12,
    display: 'block'
  }
};
interface ISwitch {
  onClick: MouseEventHandler;
  on: boolean;
}
export default (props: ISwitch) => {
  //console.log(props,'switch')
  return (
    <img
      style={style.img}
      onClick={props.onClick}
      src={
        props.on
          ? require('../../assets/switch-on.png')
          : require('../../assets/switch-off.png')
      }
      alt=""
    />
  );
};
